/**
 * Product section bootstrap.
 * Shared controller plus module registry; feature scripts register themselves.
 */

(() => {
  const PRODUCT_SECTION_TAG = 'product-page-section';
  const registeredModules = new Map();

  class ProductSectionController {
    constructor(section) {
      this.section = section;
      this.instances = new Map();
    }

    mountModule(name, initializer) {
      if (this.instances.has(name)) return this.instances.get(name);

      const instance = initializer(this) ?? true;
      this.instances.set(name, instance);
      return instance;
    }

    query(selector) {
      return this.section.querySelector(selector);
    }

    queryAll(selector) {
      return Array.from(this.section.querySelectorAll(selector));
    }

    emit(name, detail) {
      this.section.dispatchEvent(new CustomEvent(name, { detail }));
    }
  }

  function mountModuleOnConnectedSections(name, initializer) {
    document.querySelectorAll(PRODUCT_SECTION_TAG).forEach((section) => {
      section.productSection?.mountModule(name, initializer);
    });
  }

  window.HerbiProductSection = window.HerbiProductSection || {
    registerModule(name, initializer) {
      if (registeredModules.has(name)) return;

      registeredModules.set(name, initializer);
      mountModuleOnConnectedSections(name, initializer);
    }
  };


  if (customElements.get(PRODUCT_SECTION_TAG)) return;

  class ProductPageSection extends HTMLElement {
    connectedCallback() {
      if (this.productSection) return;

      this.productSection = new ProductSectionController(this);
      registeredModules.forEach((initializer, name) => {
        this.productSection.mountModule(name, initializer);
      });
    }
  }

  customElements.define(PRODUCT_SECTION_TAG, ProductPageSection);
})();

